import { StoresViewModel } from 'common/models/BookingTypes';
import { notification } from 'antd';
import { GetNotificationProps } from 'common/utils/utility';
import { APIResponseCode, MessageDisplay } from 'common/constants';
import { APIResponse, PostData } from 'common/utils/jsonFetch';
import { Validator } from 'common/validators/validators';
import { KFSEndpoints } from 'common/constants/KFSEndpoints';
import { StoresActions } from '../store/StoresSlice';
import { StoreIncentivesViewModel } from 'common/models/StoreTypes';
import { AssignBarcodesToStoreRequest, StoreBarcodeViewModel } from 'common/models/BarcodeTypes';

export const GetAllStore = () => async (dispatch) => {
  try {
    dispatch(StoresActions.submitStatus());
    const response = await PostData<APIResponse>(KFSEndpoints.Store_GetAll, null);
    new Validator(response.parsedBody?.Status).IsEqualsString(APIResponseCode.SUCCESS);
    const dataList: StoresViewModel[] = response.parsedBody?.Results;
    dispatch(StoresActions.SetStores(dataList));
    dispatch(StoresActions.submitStatusSucceeded());
  } catch (e) {
    dispatch(StoresActions.submitStatusRejected(''));
    notification.error(GetNotificationProps(MessageDisplay.GENERIC_TECHNICAL_ERROR));
  }
};

export const GetAllIncentives = (request: string) => async (dispatch) => {
  try {
    dispatch(StoresActions.submitStatus());
    const response = await PostData<APIResponse>(KFSEndpoints.Store_GetAllIncentives, request);
    new Validator(response.parsedBody?.Status).IsEqualsString(APIResponseCode.SUCCESS);
    const dataList: StoreIncentivesViewModel[] = response.parsedBody?.Results;
    dispatch(StoresActions.SetStoreIncentivesViewModel(dataList));
    dispatch(StoresActions.submitStatusSucceeded());
  } catch (e) {
    dispatch(StoresActions.submitStatusRejected(''));
    notification.error(GetNotificationProps(MessageDisplay.GENERIC_TECHNICAL_ERROR));
  }
};

export const AssignBarcodesToStore = (request: AssignBarcodesToStoreRequest) => async (dispatch) => {
  try {
    dispatch(StoresActions.submitStatus());
    const response = await PostData<APIResponse>(KFSEndpoints.Barcode_AssignToStore, request);
    if (response.parsedBody?.Status !== APIResponseCode.SUCCESS) {
      dispatch(StoresActions.submitStatusRejected(''));
      return response.parsedBody?.Message || MessageDisplay.GENERIC_TECHNICAL_ERROR;
    }
    dispatch(StoresActions.submitStatusSucceeded());
    notification.success(
      GetNotificationProps(response.parsedBody?.Message || 'Barcodes assigned to store successfully.')
    );
    return '';
  } catch (e: any) {
    dispatch(StoresActions.submitStatusRejected(''));
    return e?.parsedBody?.Message || e?.Message || MessageDisplay.GENERIC_TECHNICAL_ERROR;
  }
};

export const RemoveBarcodeFromStore = (barcodeId: string) => async (dispatch) => {
  try {
    dispatch(StoresActions.submitStatus());
    const response = await PostData<APIResponse>(KFSEndpoints.Barcode_RemoveFromStore, barcodeId);
    new Validator(response.parsedBody?.Status).IsEqualsString(APIResponseCode.SUCCESS);
    dispatch(StoresActions.submitStatusSucceeded());
    notification.success(GetNotificationProps('Barcode removed from store successfully.'));
  } catch (e) {
    dispatch(StoresActions.submitStatusRejected(''));
    notification.error(GetNotificationProps(MessageDisplay.GENERIC_TECHNICAL_ERROR));
  }
};

export const GetBarcodesByStoreId = (storeId: string) => async (dispatch) => {
  try {
    dispatch(StoresActions.submitStatus());
    const response = await PostData<APIResponse>(KFSEndpoints.Barcode_GetByStoreId, storeId);
    new Validator(response.parsedBody?.Status).IsEqualsString(APIResponseCode.SUCCESS);
    const dataList: StoreBarcodeViewModel[] = response.parsedBody?.Results;
    dispatch(StoresActions.SetStoreBarcodes(dataList));
    dispatch(StoresActions.submitStatusSucceeded());
  } catch (e) {
    dispatch(StoresActions.submitStatusRejected(''));
    notification.error(GetNotificationProps(MessageDisplay.GENERIC_TECHNICAL_ERROR));
  }
};
